import ConfigAds from '../Config'
import { AdCommonEvents } from '../constants'
import { fetchADS, Pixel1EventsDict } from '../PixelV1Handler'
import { Pixel2, Pixel2EventsDict } from '../PixelV2Handler/utils'

interface Props {
  event: AdCommonEvents
  userId?: number
}

export const callPixelEvent = ({ event, userId }: Props) => {
  const { v1, v2, mania } = ConfigAds.get() || {}

  if (mania) {
    if (v1) {
      const eventNumber = Pixel1EventsDict[mania][event]
      if (eventNumber) fetchADS({ eventNumber, userId })
    }
    if (v2) {
      if (userId) Pixel2.changeUserId(userId)
      Pixel2.callEvent(Pixel2EventsDict[event])
      const eventT = Pixel2EventsDict[event]
      Pixel2.eventPixelsDict?.[eventT].forEach((id) => {
        Pixel2.callPixelBy(id, null)
      })
    }
  }
}
